/**
 * Whole-blob last-write-wins for a team attempt (ADR 0025).
 *
 * A remote progress state is applied only when it is newer than anything this client saved
 * or applied, and never over a local edit that is still waiting to be saved: the server will
 * arbitrate that one, and the next poll reports the outcome.
 *
 * Stamps are compared as instants, not as strings: the server writes six fractional digits,
 * the client three.
 */
export function shouldApplyRemote(
  remoteStamp: string | null,
  lastStamp: string | null,
  localPending: boolean,
): boolean {
  if (!remoteStamp || localPending) return false;
  if (lastStamp === null) return true;
  return Date.parse(remoteStamp) > Date.parse(lastStamp);
}
